import React from "react";
import {View} from 'react-template';
export default class Index extends View {

    render() {
        return (
            <div className="width-100">
                <div id='inicio-admin'>
                    <div>
                        <h3>Bem Vindo!</h3>
                    </div>
                    <div>
                        <h1>Sistema de controle de formulários e GRUs da UEPB</h1>
                    </div>
                </div>
                {/* <div className='text-center'>
                    <a className='ui button' href='#'>Ajuda</a>
                </div> */}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/view/dashboard/Index.js